'use strict';
define('elements/print-lazy-images',['utils/domready'], function(domready) {
    domready(function() {
        // Fix for Chrome bug where the loading=lazy images are not loaded to print
        window.addEventListener('beforeprint', function() {
            const lazyImages = document.querySelectorAll('img[loading="lazy"]');
            if (!lazyImages.length) return;

            lazyImages.forEach(img => {
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                }
                img.loading = "eager";
            });
        })
    });
});

